import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

// Components
const CategoryProduct = lazy(() => import('../pages/CategoryProduct'));
const Home = lazy(() => import('../pages/Home'));
const Catalog = lazy(() => import('../pages/Catalog'));
const CatalogProduct = lazy(() => import('../pages/CatalogProduct'));
const Favorites = lazy(() => import('../pages/Favorites'));
const Order = lazy(() => import('../pages/Order'));
const Profile = lazy(() => import('../pages/Profile'));
const Loyalty = lazy(() => import('../pages/Loyalty/Loyalty'));
const RecipeOrder = lazy(() => import('../pages/RecipeOrder'));
const Promotions = lazy(() => import('../pages/Promotions'));
const Promo = lazy(() => import('../pages/Promo'));
const Category = lazy(() => import('../pages/Category'));

const Login = () => 'Страница входа';

const routes = [
  {
    exact: true,
    path: '/login',
    component: Login,
  },
  {
    exact: true,
    path: '/',
    component: Home,
  },
  {
    path: '/category',
    component: Category,
    exact: true,
  },
  {
    path: '/category/:product',
    component: CategoryProduct,
    exact: true,
  },
  {
    path: '/catalog/:query',
    component: Catalog,
    exact: true,
  },
  {
    path: '/catalog/:query/:product',
    component: CatalogProduct,
    exact: true,
  },
  {
    path: '/order',
    component: Order,
  },
  {
    path: '/recipe-order',
    component: RecipeOrder,
  },
  {
    path: '/favorites',
    component: Favorites,
  },
  {
    path: '/profile',
    component: Profile,
    isPrivateRoute: true,
  },
  {
    path: '/loyalty',
    component: Loyalty,
  },
  {
    path: '/promotions',
    component: Promotions,
    exact: true,
  },
  {
    path: '/promotions/:id?/:product?',
    component: Promo,
  },
  {
    path: '/drugstores',
    component: lazy(() => import('../pages/Drugstores')),
  },
  {
    path: '/order-in-drugstore/:id?',
    component: lazy(() => import('../pages/OrderInDrugstore')),
  },
  {
    path: '/',
    component: () => <Redirect to="/" />,
  },
];

export default routes;
